// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slide-status-overlay {
    position: fixed;
    bottom: 12px;
    left: 12px;
    z-index: 99998;
    width: 220px;
    padding: 10px 14px;
    background: rgba(0, 0, 0, 0.72);
    border-radius: 8px;
    color: #fff;
    font-size: 12px;
    pointer-events: none;
    backdrop-filter: blur(4px);
}

.slide-status-overlay__title {
    font-size: 13px;
    font-weight: 600;
    margin-bottom: 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.slide-status-overlay__progress-track {
    height: 4px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 2px;
    overflow: hidden;
    margin-bottom: 5px;
}

.slide-status-overlay__progress-fill {
    height: 100%;
    background: #4a9eff;
    border-radius: 2px;
    transition: width 0.4s ease;
}

.slide-status-overlay__sub {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.65);
}
`, "",{"version":3,"sources":["webpack://./react/features/slide-view/components/web/slide-status-overlay.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,UAAU;IACV,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,oBAAoB;IACpB,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC","sourcesContent":[".slide-status-overlay {\n    position: fixed;\n    bottom: 12px;\n    left: 12px;\n    z-index: 99998;\n    width: 220px;\n    padding: 10px 14px;\n    background: rgba(0, 0, 0, 0.72);\n    border-radius: 8px;\n    color: #fff;\n    font-size: 12px;\n    pointer-events: none;\n    backdrop-filter: blur(4px);\n}\n\n.slide-status-overlay__title {\n    font-size: 13px;\n    font-weight: 600;\n    margin-bottom: 6px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.slide-status-overlay__progress-track {\n    height: 4px;\n    background: rgba(255, 255, 255, 0.2);\n    border-radius: 2px;\n    overflow: hidden;\n    margin-bottom: 5px;\n}\n\n.slide-status-overlay__progress-fill {\n    height: 100%;\n    background: #4a9eff;\n    border-radius: 2px;\n    transition: width 0.4s ease;\n}\n\n.slide-status-overlay__sub {\n    font-size: 11px;\n    color: rgba(255, 255, 255, 0.65);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
